import { createMultiStyleConfigHelpers as o } from "@chakra-ui/react";
const { defineMultiStyleConfig: e, definePartsStyle: t } = o([
  "container",
  "content",
  "body",
  "suggestion",
  "status"
]), d = t({
  content: {
    paddingY: 2,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "gray.200",
    borderRadius: "lg",
    boxShadow: "lg",
    backgroundColor: "white"
  },
  body: {
    maxW: "100%",
    padding: 0
  },
  suggestion: {
    paddingX: 4,
    paddingY: { base: 1, md: 2 },
    ":hover, &.suggestion-focused": {
      backgroundColor: "gray.100",
      cursor: "arrow"
    }
  },
  status: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    border: "0px",
    overflow: "hidden"
  }
}), i = e({
  baseStyle: d
});
export {
  i as default
};
